let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jElL3")).then(() => parcelRequire('kv9oC'));